module.exports = __webpack_public_path__ + "static/media/automation-rewind-icon.4c27ed93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation-rewind-icon.svg
// module id = ./src/assets/images/automation-rewind-icon.svg
// module chunks = 0